import { createRoot } from 'react-dom/client';
import App from './app.tsx';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { queryClient } from '@r/utils/utils.ts';
import { Toaster } from '@ui/sonner.tsx';
import * as Sentry from '@sentry/react';
import { isProd } from '@r/utils/utils.ts';
import i18n from '@r/lib/i18n.ts';
import { I18nextProvider } from 'react-i18next';
import { ServerErrorProvider } from '@r/context/server-error-provider.tsx';

// init sentry
Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: isProd()
    ? 'https://cdb37d466df4463cc297b69b78178399@o158705.ingest.us.sentry.io/4508444540993536'
    : undefined,
  integrations: []
});

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <ServerErrorProvider>
          <App />
        </ServerErrorProvider>
      </I18nextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
      <Toaster closeButton richColors />
    </QueryClientProvider>
  </StrictMode>
);
